import { ALERT, CLEAN, ERROR, SET_TYPES, IS_FETCHING, IS_SENDING, GET_TYPES, SET_TYPE } from "./types";

const EquipmentOrToolsTypesReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case CLEAN:
            return {
                types: [],
                typesSearcheable: [],
                type: {
                    equipmentDescription: '',
                    equipmentEnabled: true,
                },
                isFetching: true,
                isSending: false,
                error: false,
                errorMessage: '',
                successAlert: false,
                successMessage: '',
            };
        case IS_FETCHING:
            return {
                ...state,
                isFetching: payload,
            };
        case IS_SENDING:
            return {
                ...state,
                isSending: payload,
            };
        case GET_TYPES:
            return {
                ...state,
                typesSearcheable: payload,
                types: payload,
            };
        case SET_TYPES:
            return {
                ...state,
                types: payload,
            };
        case SET_TYPE:
            return {
                ...state,
                type: payload,
            };
        case ERROR:
            return {
                ...state,
                error: payload.value,
                errorMessage: payload.errorMessage,
            };
        case ALERT:
            return {
                ...state,
                alert: payload.value,
                alertMessage: payload.alertMessage,
            };

        default:
            return state;
    }
}

export default EquipmentOrToolsTypesReducer